export const translateCard = (windowWidth: number, cardWidth: number, gutter: number, cardIndex: number) => {
  //start represents the first card centered
  const start = windowWidth / 2 - cardWidth / 2;
  const gutters = gutter * cardIndex;
  const cards = cardWidth * cardIndex;
  const pos = start - gutters - cards; 
  return pos;
};
